import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ITRDataCollectionUI from './ITRDataCollectionUI.js'

class ITRDataCollectionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // re-collect ITR report
      itrErrorList: null,
      itrSuccessMsg: null,
      itrSubmitted: false,
      // download files
      downloadRequested: false,
      fileErrorList: null,
      //
      skipCollectionModeITR: false,
      itrSkippedSuccessMsg: null,
      itrSkippedErrorList: [],
      //
      itrReuploadErrorList: null,
      itrReuploadSuccessMsg: null,
      itrReuploadSubmitted: false,
      //
      itrJsonUploadMode: false,
      itrJsonUploadErrorList: [],
      itrExcelUploadMode: false,
      itrExcelUploadErrorList: []
    }
  }

  render() {
    return (
      <ITRDataCollectionUI
        context={this.props.context}
        account={this.props.account}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        //
        itrErrorList={this.state.itrErrorList}
        itrSuccessMsg={this.state.itrSuccessMsg}
        itrSubmitted={this.state.itrSubmitted}
        itrFileList={this.props.itrFileList}
        onITRSubmit={this.onITRSubmit}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        //
        onSkipCollectionITR={this.onSkipCollectionITR}
        skipCollectionModeITR={this.state.skipCollectionModeITR}
        itrSkippedSuccessMsg={this.state.itrSkippedSuccessMsg}
        itrSkippedErrorList={this.state.itrSkippedErrorList}
        //
        itrReuploadErrorList={this.state.itrReuploadErrorList}
        itrReuploadSuccessMsg={this.state.itrReuploadSuccessMsg}
        itrReuploadSubmitted={this.state.itrReuploadSubmitted}
        onITRReuploadClick={this.onITRReuploadClick}
        //
        itrJsonUploadMode={this.state.itrJsonUploadMode}
        onItrJsonUploadClick={() => { this.setState({ itrJsonUploadMode: true }) }}
        onItrJsonCancelUploadClick={() => { this.setState({ itrJsonUploadMode: false }) }}
        onItrJsonUpload={this.onItrJsonUpload}
        itrJsonUploadErrorList={this.state.itrJsonUploadErrorList}
        //
        itrExcelUploadMode={this.state.itrExcelUploadMode}
        onItrExcelUploadClick={() => { this.setState({ itrExcelUploadMode: true }) }}
        onItrExcelCancelUploadClick={() => { this.setState({ itrExcelUploadMode: false }) }}
        onItrExcelUpload={this.onItrExcelUpload}
        itrExcelUploadErrorList={this.state.itrExcelUploadErrorList}
      />
    )
  }

  componentDidMount = () => {
    let context = this.props.context
  }

  onITRSubmit = () => {
    let itrSubmitted = this.state.itrSubmitted
    if (itrSubmitted)
      return

    this.setState({
      itrSuccessMsg: null,
      itrErrorList: [],
      itrSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/itrReport/enableReCollection`,
      this.onITRSubmitCallback, {}
    )
  }

  onITRSubmitCallback = (response) => {
    let itrErrorList = []
    response.errorList.forEach(error => {
      itrErrorList.push(error.message)
    })

    this.setState({
      itrSuccessMsg: response.success,
      itrErrorList: itrErrorList,
      itrSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ itrSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ itrErrorList: [] })
      }, 5000)
    }
  }

  onSkipCollectionITR = (event) => {
    console.log("skipcollectionITR")
    this.setState({ skipCollectionModeITR: true })
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/itrReport/skipCollection`, this.onSkipCollectionITRCallback, null, null
    )
  }

  onSkipCollectionITRCallback = (response) => {
    console.log("done")
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      itrSkippedSuccessMsg: response.success,
      itrSkippedErrorList: errorList,
      skipCollectionModeITR: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick()
      }, 3000)
    }
  }

  onDownloadFileClick = (event) => {
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      window.open(response.signedUrl.signedUrl, '_blank')
    }
  }

  onITRReuploadClick = () => {
    let itrReuploadSubmitted = this.state.itrReuploadSubmitted
    if (itrReuploadSubmitted)
      return

    this.setState({
      itrReuploadSuccessMsg: null,
      itrReuploadErrorList: [],
      itrReuploadSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreMe/ITR/scoreParameters`,
      this.onITRReuploadClickCallback, {}
    )
  }

  onITRReuploadClickCallback = (response) => {
    let itrReuploadErrorList = []
    response.errorList.forEach(error => {
      itrReuploadErrorList.push(error.message)
    })

    this.setState({
      itrReuploadSuccessMsg: response.success,
      itrReuploadErrorList: itrReuploadErrorList,
      itrReuploadSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ itrReuploadSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ itrReuploadErrorList: [] })
      }, 5000)
    }
  }

  onItrJsonUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/itrReport/json/validation`,
      this.onItrJsonUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onItrJsonUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      itrJsonUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onItrExcelUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/itrReport/excel/validation`,
      this.onItrExcelUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onItrExcelUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      itrExcelUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

}

export default ITRDataCollectionSF
